import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { AuthService } from 'src/app/shared/services/auth.service';
import { LoginService } from 'src/app/shared/services/login.service';
import { StorageService } from 'src/app/shared/services/storage.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-unauthorized',
  templateUrl: 'unauthorized.component.html',
  styleUrls: ['unauthorized.component.scss'],
})
export class UnauthorizedComponent extends BaseFormComponent<any> implements OnInit {
  invalido: string;
  date = new Date();
  recuperar: any = {
    cpf: '',
    active: false,
  };
  currentEntidade: number|null = null;
  entidades: Record<string, any>[] = [];
  form:FormGroup;

  constructor(
    private authService: AuthService,
    private router: Router,
    private storageService: StorageService,
    public activatedRoute: ActivatedRoute,
    private loginService: LoginService,
  ) {
    super(activatedRoute);
  }

  ngOnInit():void  {
    this.loaded();
    //this.authService.cleanJWT();
    this.authService.logout();
    this.storageService.removeFilterAll();
    this.initForm();

    if(window.location.hostname === 'localhost' || window.location.hostname === 'smg-teste.rs.gov.br'){
      const arrayLogin = {
        usuario: '40505959070',
        senha: '333444',
        entidade: '1'
      }
      this.loading();

      this.authService
        .autorize(arrayLogin)
        .then((redirecUrl) => {
          this.loaded();
          if (this.authService.getRedirectTo()) {
            window.location.href = this.authService.getRedirectTo();
          } else {
            window.location.href = redirecUrl;
          }
        })
        .catch((error) => {
          this.loaded();
          console.log(error)
          console.log(error?.message)
          this.invalido =
            error?.message != null
              ? error?.message + '.'
              : 'Erro ao tentar acessar o Servidor, contate o Administrador do Sistema';
        });
    } else {
      this.getEntidades();
    }
    this.getQueryParams();
    this.activatedRoute.queryParams.subscribe({
      next: (urlParams: any) => {
        if (urlParams['redirect']) {
          this.authService.setRedirectTo(urlParams['redirect']);
        }
        if (urlParams['trylogin'] && urlParams['trylogin'] == 'soe') {
          this.loginSoe();
        }
      },
    });
    
  }

  initForm(): void {
    this.form = new FormGroup({
      entidade: new FormControl(null),
      usuario: new FormControl('', [Validators.required]),
      senha: new FormControl('', [Validators.required]),
    });
  }

  login():void {
    if (this.form.valid) {
      this.loading();
      const filteredParams = Object.fromEntries(
        Object.entries(Object.assign({}, this.form.value)).filter(([_, value]) => value !== null && value !== undefined)
      );
      this.authService
        .autorize(filteredParams)
        .then((redirecUrl) => {
          this.loaded();
          if (this.authService.getRedirectTo()) {
            window.location.href = this.authService.getRedirectTo();
          } else {
            window.location.href = redirecUrl;
          }
        })
        .catch((error) => {
          this.loaded();
          console.log(error)
          console.log(error?.message)
          this.invalido =
            error?.message != null
              ? error?.message + '.'
              : 'Erro ao tentar acessar o Servidor, contate o Administrador do Sistema';
        });
    } else {
      this.markAsDirty();
    }
  }


  getEntidades():void {
    this.loading();
    this.loginService.getEntidades().subscribe({
      next: (value) => {
        this.loaded()
        this.entidades = value;
      },
      error: (err) => {
        this.loaded()
        this.msgError(typeof err.error !== 'object' ? err.error : err.message);
      },
    })
  }
  
  loginSoe():void {
    this.authService
      .soewebAuthentication()
      .then((redirecUrl) => {
        window.location.href = redirecUrl;
      })
      .catch((error) => {
        console.log(error);
      });
  }

  loginDropbox():void {
    this.authService
      .dropboxAuthentication()
      .then((redirecUrl) => {
        window.location.href = redirecUrl;
      })
      .catch((error) => {
        console.log(error);
      });
  }

  recuperarActive(event: Event):void {
    event.preventDefault();
    this.recuperar.cpf = '';
    this.recuperar.active = !this.recuperar.active;
  }

  recuperarSenha():void {
    this.loading();
    let cpf = this.recuperar.cpf.replace(/\D/g, '');
    this.loginService.getRecuperarSenha(cpf).subscribe({
      next: (value) => {
        this.loaded()
        this.msgSuccess(value);
      },
      error: (err) => {
        this.loaded()
        this.msgError(typeof err.error !== 'object' ? err.error : err.message);
      },
    })
  }

  urlRecuperacaoAntiga(): string {
    return environment.serverUrl + '/esqueci-senha/';
  }

  getQueryParams(){
    this.activatedRoute.queryParams.subscribe(params => {
      if (params) {
        try {
          const entidade = params['entidade'] ?? this.currentEntidade;
          this.currentEntidade = entidade? +(entidade) : null;
          if(this.form){
            console.log(this.currentEntidade)
            this.form.get('entidade')?.setValue(this.currentEntidade);
          }
        } catch (e) {
          console.error('Erro ao aplicar filtro dos query params', e);
        }
      }
    });
  }
  
  saveQueryParams() {
    this.currentEntidade = this.form.get('entidade')?.value;
    if(this.currentEntidade != null){
      this.router.navigate([], {
        relativeTo: this.activatedRoute,
        queryParams: { entidade: this.currentEntidade},
        queryParamsHandling: 'merge',
        replaceUrl: true
      });
    }
  }
}
